module.exports = __webpack_public_path__ + "img/love_lock_gift.78ca673f.svg";